export enum AdapterRole {
    /** The ad adapter role identifier  */
    AD = 'ad',
    PLAYBACK = 'playback',
}
